import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { InputSelectRadioButton } from '../../models/pages-model/form-general.model';

@Component({
  selector: 'app-input-general-radio-button',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatRadioModule, TranslateModule],
  templateUrl: './input-general-radio-button.component.html',
})
export class InputGeneralRadioButtonComponent {
  @Input() formControlGeneral: FormControl | AbstractControl | null = new FormControl();
  @Input() placeholder = '';
  @Input() label = '';
  @Input() nameCards = '';
  @Input() InputSelectRadioButton: InputSelectRadioButton = { value: '', description: '' };
  @Input() arrayData: any = [];

  public getNestedProperty(obj: any, path: string): any {
    const pathArray = path.split('.');
    return pathArray.reduce((acc, current) => (acc ? acc[current] : null), obj);
  }

  getInputGeneral(): FormControl {
    return this.formControlGeneral as FormControl;
  }

  changeValue(item: any): void {
    if (this.getInputGeneral().enabled) {
      this.formControlGeneral?.setValue(
        this.getNestedProperty(item, this.InputSelectRadioButton.value),
      );
    }
  }
}
